/** The same branded outline and count in the site navigation and native header. */
export function ChatClip({unreadCount}:{unreadCount:number}) {
  return <svg className="nav-chat-clip" aria-hidden="true" viewBox="0 0 138 44" preserveAspectRatio="none" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
    <path className="nav-chat-clip__wire" d="M35 4H116a18 18 0 0 1 0 36H22A18 18 0 0 1 4 22"/>
    <text className="nav-chat-clip__count" x="69" y="22" dy=".35em" textAnchor="middle">{unreadCount>99?'99+':unreadCount}</text>
  </svg>;
}
